import React from "react";
import { cleanJoin } from "../../utils/stringUtil";

function Row({ isGapless = false, children, className, ...rest }) {
  return (
    <div className={cleanJoin("columns", isGapless ? "is-gapless" : "", className)} {...rest}>
      {children}
    </div>
  );
}

export default Row;
